"use client";

import React from "react";
import { Download, FileImage, Maximize2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function ImageDisplay() {
  return;
}